export default __webpack_public_path__ + "static/media/lectureNotes.471772f2.svg";